module.exports = require('./helpers/bundle-url').getBundleURL('dUdTx') + "logo.c51670a8.svg";